import styled, { css } from 'styled-components';

export const Card = styled.section(
  ({ theme: { palette } }) => css`
    background-color: ${palette.common.white};
    border: 1px solid ${palette.grey[300]};
    border-radius: 8px;
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
  `,
);

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 24px;
`;

export const Title = styled.h3(
  ({ theme: { palette } }) => css`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${palette.text.secondary};
  `,
);

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

export const Body = styled.div<{ $height?: number }>(
  ({ $height }) => css`
    flex-grow: 1;
    min-width: 0;
    ${$height !== undefined &&
    css`
      height: ${$height}px;
    `}
  `,
);
